import { useRootLoaderData } from '~/common/utils/useRootLoaderData';

export function useDeploymentInfo() {
  const loaderData = useRootLoaderData();
  
  return loaderData.deploymentInfo;
}
